import React from "react";
import PropTypes from "prop-types";
import { Table, Spin, Grid, Button, Popconfirm, message } from "antd";
import { createShipping } from "../../../../Services/ShippingService";
import { updateStockOpname } from "../../../../Services/StockOpnameService";
import {
  getStocksByBarcodeCC,
  createStock,
} from "../../../../Services/StockService";
const { useBreakpoint } = Grid;

const StockOpnameTable = ({
  loading,
  data,
  pagination,
  onPaginationChange,
  dispatch,
  userData,
  updateStockQuantity, // function to update the stock
  callRefetch, // function to reload the data
  rowSelection,
  onApprove,
  onReject,
}) => {
  const screens = useBreakpoint();

  const handleTableOnChange = (paginationParams, filteredInfo, sorter) => {
    dispatch({ type: "sorter", payload: sorter });
    dispatch({ type: "filteredInfo", payload: filteredInfo });

    if (onPaginationChange && paginationParams) {
      onPaginationChange(paginationParams.current, paginationParams.pageSize);
    }
  };



  const handleApproved = async (record) => {
       if (record.__approving) return;
   record.__approving = true;

    const payload = {
      counterCode: userData?.counterCode,
      barcode: record.barcode,
      currentQuantity: record.soQuantity, // update stock to match SO
    };

    const pad2 = (n) => n.toString().padStart(2, "0");
    const now = new Date();
    const dateString = `${pad2(now.getDate())}${pad2(
      now.getMonth() + 1
    )}${now.getFullYear()}`;

    const shippingData = {
      noForm: `SON-${record.counterCode}-${dateString}`,
      noSJ: `SON-${record.counterCode}-${dateString}`,
      sender: "SO",
      destination: record.counterCode,
      status: "in stock",
      tanggal_kirim: now,
      dateReceived: now,
    };

    const sameStock = await getStocksByBarcodeCC(
      record.barcode,
      record.counterCode
    );
    const selectedStock = sameStock?.data[0];
    const stockData = {
      noSJ: `SON-${record.counterCode}-${dateString}`,
      article: selectedStock.article || "",
      color: selectedStock.color || "",
      size: selectedStock.size || "",
      quantity: record.soQuantity - record.totalAllQuantity,
      currentQuantity: record.soQuantity - record.totalAllQuantity,
      price: isNaN(selectedStock.price) ? 0 : selectedStock.price,
      barcode: selectedStock.barcode,
      counterCode: selectedStock.counterCode,
      currCounterCode: userData.counterCode,
      status: "in stock",
    };
    try {
      await updateStockOpname(record._id, {
        status: "A",
        stockAdjustment: record.soQuantity - record.totalAllQuantity,
      });
      try {
        await createShipping(shippingData);
      } catch (error) {
        message.info("Creating for the same noSJ");
      }

      if (record.soQuantity - record.totalAllQuantity != 0) {
        await createStock(stockData);
      }
      // await updateStockQuantity(payload);
      message.success(`Approved stock for barcode ${record.barcode}`);
      if (onApprove) onApprove(record._id); // <-- Call the parent's handler
    } catch (error) {
      console.error("Error updating stock quantity:", error);
      message.error("Failed to approve stock");
    }
    finally{
      record.__approving = false;
    }
  };

  const handleReject = async (record) => {
    try {
      await updateStockOpname(record._id, { status: "R" });
      message.success(`Rejected stock for barcode ${record.barcode}`);
      if (onReject) onReject(record._id);
    } catch (error) {
      console.error("Error rejecting stock:", error);
      message.error("Failed to reject stock");
    }
  };

  const columns = [
    {
      title: "Checked Date",
      dataIndex: "checkedDate",
      key: "checkedDate",
      sorter: true,
      render: (date) =>
        date ? new Date(date).toLocaleDateString("id-ID") : "-",
    },
    {
      title: "Counter Code",
      dataIndex: "counterCode",
      key: "counterCode",
      sorter: true,
    },
    {
      title: "Checker",
      dataIndex: "checker",
      key: "checker",
      sorter: true,
    },
    {
      title: "Barcode",
      dataIndex: "barcode",
      key: "barcode",
      sorter: true,
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      sorter: true,
      render: (sku, record) =>
        userData?.counterCode === "ECOMMRI" ? sku || "-" : "-",
    },
    {
      title: "Article",
      dataIndex: "articleName",
      key: "articleName",
      sorter: true,
    },
    {
      title: "Current Quantity",
      dataIndex: "totalCurrentQuantity",
      key: "totalCurrentQuantity",
      sorter: true,
    },
    {
      title: "Transaction Quantity",
      dataIndex: "totalTransactionQuantity",
      key: "totalTransactionQuantity",
      sorter: true,
    },
    {
      title: "Backdate Quantity",
      dataIndex: "totalAllQuantity",
      key: "totalAllQuantity",
      sorter: true,
    },
    {
      title: "SO Quantity",
      dataIndex: "soQuantity",
      key: "soQuantity",
      sorter: true,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: 8 }}>
          <Popconfirm
            title="Are you sure to approve this change?"
            onConfirm={() => handleApproved(record)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="primary" size="small" loading={record.__approving}>
              Approve
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div
      style={{
        width: "100%",
        overflowX: "auto",
        padding: screens.xs ? "10px" : "20px",
      }}
    >
      <Spin spinning={loading} tip="Loading stock opname data...">
        <Table
          columns={columns}
          dataSource={data}
          onChange={handleTableOnChange}
          pagination={{
            current: pagination?.current || 1,
            pageSize: pagination?.pageSize || (screens.xs ? 5 : 10),
            total: pagination?.total || 0,
            showSizeChanger: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
            pageSizeOptions: ["10", "20", "50", "100"],
          }}
          scroll={screens.xs ? { x: "max-content" } : undefined}
          rowKey="_id"
          rowSelection={rowSelection} // <-- add this line
        />
      </Spin>
    </div>
  );
};

StockOpnameTable.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array,
  pagination: PropTypes.object,
  onPaginationChange: PropTypes.func,
  dispatch: PropTypes.func,
  updateStockQuantity: PropTypes.func.isRequired,
  callRefetch: PropTypes.func.isRequired,
};

export default StockOpnameTable;
